export default __webpack_public_path__ + "static/media/left-arrow.78d243bd.svg";